// src/pages/Contact.js
import React from 'react';
import { Link } from 'react-router-dom';

const Contact = () => {
  const img = (path) => process.env.PUBLIC_URL + path;

  return (
    <div className="boxed_wrapper ltr">
      {/* Banner */}
      <section className="page-title centred pt_130 pb_150" style={{ backgroundImage: `url(${img('/assets/images/banner/translation.jpg')})`, backgroundSize: 'cover', backgroundPosition: 'center', position: 'relative' }}>
        <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.4)', zIndex: 1 }}></div>
        <div className="pattern-layer" style={{ position: 'relative', zIndex: 2 }}>
          <div className="pattern-1" style={{ backgroundImage: `url(${img('/assets/images/shape/shape-64.png')})` }}></div>
          <div className="pattern-2" style={{ backgroundImage: `url(${img('/assets/images/shape/shape-65.png')})` }}></div>
        </div>
        <div className="auto-container" style={{ position: 'relative', zIndex: 3 }}>
          <div className="content-box">
            <span className="sub-title-three" style={{ color: '#fff' }}>Contact</span>
            <h1 style={{ color: '#fff' }}>Contact Us</h1>
          </div>
        </div>
      </section>

      {/* Contact Info */}
      <section className="contact-info-section centred pt_150 pb_120">
        <div className="auto-container">
          <div data-animation-box className="sec-title mb_55">
            <span className="sub-title overlay-anim-white-bg" data-animation="overlay-animation">Contact Info</span>
            <h2>Contact Information</h2>
          </div>
          <div className="row clearfix">
            {[
              {
                icon: 'icon-48',
                title: 'Location',
                text: '114 2nd Cross Rd, Wattala, Sri Lanka',
              },
              {
                icon: 'icon-49',
                title: 'Email Address',
                text: <a href="mailto:info@wications.com">info@wications.com</a>,
              },
              {
                icon: 'icon-50',
                title: 'Phone Number',
                text: <a href="tel:94-11-2655017">94-11-2655017</a>,
              }
            ].map((info, idx) => (
              <div className="col-lg-4 col-md-6 col-sm-12 info-block" key={idx}>
                <div className="info-block-one aos-init aos-animate" data-aos="fade-up" data-aos-easing="linear" data-aos-duration={700 + idx * 200}>
                  <div className="inner-box">
                    <div className="icon-box"><i className={info.icon}></i></div>
                    <h3>{info.title}</h3>
                    <p>{info.text}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Google Map */}
      <section className="google-map-section pb_150">
        <div className="default-pattern">
          <div className="pattern-1" style={{ backgroundImage: `url(${img('/assets/images/shape/shape-68.png')})` }}></div>
          <div className="pattern-2" style={{ backgroundImage: `url(${img('/assets/images/shape/shape-69.png')})` }}></div>
        </div>
        <div className="auto-container">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3960.146245259039!2d79.8818654747577!3d6.9920503930090385!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae2f7d0669a8f09%3A0x4975e69756667281!2s114%202nd%20Cross%20Rd%2C%20Wattala%2C%20Sri%20Lanka!5e0!3m2!1sen!2sin!4v1745085549796!5m2!1sen!2sin"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            title="Google Map"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </section>

      {/* Contact Form */}
      <section className="contact-section pt_140 pb_150">
        <div className="auto-container">
          <div className="sec-title mb_55 centred" data-animation-box>
            <span className="sub-title overlay-anim-white-bg" data-animation="overlay-animation">Contact Form</span>
            <h2>Get in Touch</h2>
          </div>
          <div className="form-inner">
            <form id="contact-form">
              <div className="row clearfix">
                {[
                  { type: 'text', name: 'username', placeholder: 'Your Name' },
                  { type: 'email', name: 'email', placeholder: 'Your email' },
                  { type: 'text', name: 'phone', placeholder: 'Phone' },
                  { type: 'text', name: 'subject', placeholder: 'Subject' },
                ].map((field, i) => (
                  <div key={i} className="col-lg-6 col-md-6 col-sm-12 form-group">
                    <input type={field.type} name={field.name} placeholder={field.placeholder} required />
                  </div>
                ))}
                <div className="col-lg-12 col-md-12 col-sm-12 form-group">
                  <textarea name="message" placeholder="Type message"></textarea>
                </div>
                <div className="col-lg-12 col-md-12 col-sm-12 form-group message-btn centred">
                  <button className="theme-btn btn-one" type="submit">Post a Comment</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="bg-color"></div>
        <div className="auto-container">
          <div className="inner-container">
            <div className="pattern-layer">
              {[23, 24, 25, 26].map((n) => (
                <div key={n} className={`pattern-${n - 22} ${n !== 23 ? 'rotate-me' : ''}`} style={{ backgroundImage: `url(${img('/assets/images/shape/shape-' + n + '.png')})` }}></div>
              ))}
            </div>
            <div className="inner-box">
              <h2>Let’s Bridge the Language Gap – <br />Get Started Now</h2>
            <div className="btn-box pt-3">
                            <Link to="/contact" className="theme-btn btn-one">Get Started</Link>
                          </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;